import { Grid } from "@mui/material";
import MxLoading from "@rf-l1/loading/MxLoading";
import useReadOnlyModeGuard from "@rf-hooks/useReadOnlyModeGuard";
import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface IReadOnlyRouteGuardProps {
  redirectTo: string | ((params: Record<string, string | undefined>) => string);
}

const ReadOnlyRouteGuard = ({ redirectTo }: IReadOnlyRouteGuardProps) => {
  const navigate = useNavigate();
  const params = useParams();
  const { showReadOnlyModal } = useReadOnlyModeGuard();
  const hasShownModal = useRef(false);

  useEffect(() => {
    if (hasShownModal.current) return;
    hasShownModal.current = true;

    const destination =
      typeof redirectTo === "function" ? redirectTo(params) : redirectTo;

    showReadOnlyModal().finally(() => {
      navigate(destination, { replace: true });
    });
  }, [navigate, params, redirectTo, showReadOnlyModal]);

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{ minHeight: "70vh" }}
    >
      <MxLoading variant="gradient" />
    </Grid>
  );
};

export default ReadOnlyRouteGuard;
